// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Text } from 'informed';
import { throttle } from 'throttle-debounce';

import styles from '../../styles/PharmacySidebarInfo.scss';

type Props = {
  updatePharmacyFilter: Function,
}

class PharmacySidebarInfoComponent extends Component<Props> {
  formApi: {
    getState: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  updatePharmacyFilter = () => {
    this.props.updatePharmacyFilter(this.formApi.getState().values.pharmacyFilter);
  }

  updatePharmacyFilterThrottled = throttle(500, this.updatePharmacyFilter);

  render() {
    return (
      <div className={styles.sidebarInfo}>
        <div className={styles.name}>Pharmacy</div>
        <Form getApi={this.setFormApi} autoComplete='off'>
          <div className={styles.filterLabel}>Filter</div>
          <Text field='pharmacyFilter' onKeyUp={this.updatePharmacyFilterThrottled} />
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updatePharmacyFilter: pharmacyFilter => dispatch({
    type: 'PHARMACY_FILTER_UPDATE',
    data: pharmacyFilter,
  }),
});

const PharmacySidebarInfo = connect(
  null,
  mapDispatchToProps,
)(PharmacySidebarInfoComponent);

export default PharmacySidebarInfo;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/PharmacySidebarInfo.jsx